import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_DOCUMENTS_LABELS_BY_COMPANY } from './get-documents-labels.hook';

export const DELETE_DOCUMENT_LABEL_BY_ID = gql`
  mutation deleteDocumentLabelById($documentLabelId: String!) {
    deleteDocumentLabelById(documentLabelId: $documentLabelId) {
      _id
    }
  }
`;

export const useDeleteDocumentLabelById = () => {
  const { t } = useTranslation(['common', 'settings']);
  const [deleteDocumentLabelById] = useMutation(DELETE_DOCUMENT_LABEL_BY_ID, {
    refetchQueries: [GET_DOCUMENTS_LABELS_BY_COMPANY],
    onError: (error: any) =>
      showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('common:notifications.error.title'),
        ...(error && { description: error.errorMessage }),
      }),
  });

  return deleteDocumentLabelById;
};
